import { render, staticRenderFns } from "./advisoryNotice.vue?vue&type=template&id=8c3cf57e&scoped=true"
import script from "./advisoryNotice.vue?vue&type=script&lang=js"
export * from "./advisoryNotice.vue?vue&type=script&lang=js"
import style0 from "./advisoryNotice.vue?vue&type=style&index=0&id=8c3cf57e&prod&lang=less&scoped=true"
import style1 from "./advisoryNotice.vue?vue&type=style&index=1&id=8c3cf57e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3cf57e",
  null
  
)

export default component.exports